<template>
  <v-dialog
    v-model="show"
    max-width="800"
    persistent
    :fullscreen="this.$vuetify.breakpoint.xs"
  >
    <v-card>
      <v-row align="center" class="pa-5 ma-0">
        <v-col>
          <div class="text-left display-1 font-weight-light">
            Activatie:
            <strong class="display-2 ml-2">{{
              chosenPromotion.item.title
            }}</strong>
          </div>
        </v-col>
        <v-col class="text-right">
          <v-btn icon @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row align="center" class="pa-5 ma-0">
        <v-col><canvas id="promotion-qr"></canvas></v-col>
        <v-col class="text-center display-2 font-weight-light">
          <div>
            Deze QR-code is bij 'organiatie' in te wisselen voor de gekozen
            promotie. Uw zegels voor campagne
            <div class="font-weight-regular">
              {{ chosenPromotion.campaign.loyalty_system.name }}
            </div>
            worden pas afgeschreven zodra de QR-code is gebruikt.
          </div>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <div class="pa-5">
        <v-row class="text-center">
          <v-col
            ><v-btn text color="primary" @click="downloadCanvas('promotion-qr')"
              >Download</v-btn
            ></v-col
          >
          <v-col>
            <v-btn text color="primary" @click="printCanvas('promotion-qr')">
              Print
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "PrintPromotionDialog",
  props: ["chosen_promotion", "value"],
  mounted() {
    this.chosenPromotion = this.chosen_promotion;
  },
  updated() {
    this.setCanvas();
  },
  data() {
    return {
      chosenPromotion: { item: {}, campaign: { loyalty_system: {} } }
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  watch: {
    show: function(val) {
      if (val) {
        //setting qr
        this.chosenPromotion = this.chosen_promotion;
      }
    }
  },
  methods: {
    downloadCanvas(id) {
      let link = document.createElement("a");
      link.download = "qr-promotion.png";
      link.href = document.getElementById(id).toDataURL();
      link.click();
    },
    async printCanvas(id) {
      let src = document.getElementById(id).toDataURL("image/png");
      let newWindow = window.open("", "_blank");
      newWindow.document.write('<img src="' + src + '"/>');
      newWindow.document.title = this.chosenPromotion.item.title;
      newWindow.document.close();
      newWindow.print();
    },
    setCanvas() {
      let QRCode = require("qrcode");
      let canvas = document.getElementById("promotion-qr");
      QRCode.toCanvas(
        canvas,
        this.chosenPromotion.item.barcode,
        { width: 300 },
        function() {}
      );
    }
  }
};
</script>

<style scoped></style>
